import React from 'react';

import EnterpriseSalesAgentOverview from '../components/enterprise/sales-agent'

class EnterpriseSalesAgentOverviewPage extends React.Component{

	render(){
        console.log("HELLO WORLD")
		return (
			<div style={{margin: 16}}>
				<EnterpriseSalesAgentOverview />
			</div>
		)
	}

}

export default EnterpriseSalesAgentOverviewPage;


// WEBPACK FOOTER //
// ./src/containers/enterprise-sales-agent-page.js